import { Routes } from '@angular/router';
import { DummySimulationPage } from './pages/dummy-simulation/dummy-simulation.page';
import { SimulationPage } from './pages/simulation/simulation.page';

export const routes: Routes = [
  {
    component: SimulationPage,
    path: '',
  },
  {
    component: DummySimulationPage,
    path: 'dummy-simulation',
  },
];
